import React, { Component } from 'react'
import './ButtonSuccess.css'

export default class ButtonSuccess extends Component {
    render() {
        return (
            <button {...this.props} className={"btn-tertium-success "+this.props.className}>{ this.props.children }</button>
        )
    }
}